import { render, staticRenderFns } from "./QuizMultipleChoiceSingleAnswer.vue?vue&type=template&id=0bfc1c26&"
import script from "./QuizMultipleChoiceSingleAnswer.vue?vue&type=script&lang=js&"
export * from "./QuizMultipleChoiceSingleAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuizMultipleChoiceSingleAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports